/**
 * Automation Module - Messages Automation Mutation Services
 * Migrated from src/services/useAutomation.ts
 */

import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import {
  GENERATE_PREDEFINED_AUTOMATIONS_URL,
  UPDATE_ACTIVITY_URL,
  SET_ONBOARDING_COMPLETE_URL,
  SYNC_PROPERTY_URL,
} from '../constants';
import type { ErrorTypeAutomation } from '../types';

export const useGeneratePreDefinedAutomations = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: ErrorTypeAutomation) => void;
}) => {
  const { apiPrivate } = useApi();

  return useMutation({
    mutationFn: async (body: any) => {
      const { data } = await apiPrivate.post(GENERATE_PREDEFINED_AUTOMATIONS_URL, body);
      return data;
    },
    onSuccess: () => onSuccess && onSuccess(),
    onError: (error: ErrorTypeAutomation) => onError && onError(error),
  });
};

export const useUpdateActivity = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: ErrorTypeAutomation) => void;
}) => {
  const { apiPrivate } = useApi();

  return useMutation({
    mutationFn: async (body: any) => {
      const { data } = await apiPrivate.post(`${UPDATE_ACTIVITY_URL}?Id=${body.id}`);
      return data;
    },
    onSuccess: () => onSuccess && onSuccess(),
    onError: (error: ErrorTypeAutomation) => onError && onError(error),
  });
};

export const useSetOnboardingComplete = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: ErrorTypeAutomation) => void;
}) => {
  const { apiPrivate } = useApi();

  return useMutation({
    mutationFn: async (body: any) => {
      const { data } = await apiPrivate.post(`${SET_ONBOARDING_COMPLETE_URL}?Id=${body.id}`);
      return data;
    },
    onSuccess: () => onSuccess && onSuccess(),
    onError: (error: ErrorTypeAutomation) => onError && onError(error),
  });
};

export const useSyncProperty = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: ErrorTypeAutomation) => void;
}) => {
  const { apiPrivate } = useApi();

  return useMutation({
    mutationFn: async (id: any) => {
      const { data } = await apiPrivate.patch(SYNC_PROPERTY_URL, id, {
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
        },
      });
      return data;
    },
    onSuccess: () => onSuccess && onSuccess(),
    onError: (error: ErrorTypeAutomation) => onError && onError(error),
  });
};
